import React, { useEffect, useState } from 'react';
import DataTable from '../../components/tables/DataTable';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import Toast from '../../components/common/Toast';
import { useToast } from '../../hooks/useToast';
import companyService from '../../services/companyService';

const toDisplayDate = (isoDate) => {
  try {
    return new Date(isoDate).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    });
  } catch {
    return '-';
  }
};

const ManagerCompanyView = () => {
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const { toasts, removeToast, error } = useToast();

  useEffect(() => {
    loadCompanies();
  }, []);

  useEffect(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();
    if (!normalizedSearch) {
      setFilteredCompanies(companies);
      return;
    }

    const filtered = companies.filter((company) =>
      company.company_name.toLowerCase().includes(normalizedSearch)
    );
    setFilteredCompanies(filtered);
  }, [companies, searchTerm]);

  const loadCompanies = async () => {
    setLoading(true);
    const result = await companyService.getAllCompanies();
    if (result.success) {
      setCompanies(result.data);
      setFilteredCompanies(result.data);
    } else {
      error(result.error || 'Failed to load companies');
    }
    setLoading(false);
  };

  const filterBarStyle = {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '24px',
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    alignItems: 'flex-end'
  };

  const filterGroupStyle = {
    flex: '1',
    minWidth: '220px'
  };

  const columns = [
    {
      key: 'company_name',
      label: 'Company Name',
      render: (value) => <span style={{ fontWeight: '600' }}>{value}</span>
    },
    {
      key: 'created_at',
      label: 'Created On',
      render: (value) => toDisplayDate(value)
    }
  ];

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '60px', color: 'var(--text-secondary)' }}>
        Loading companies...
      </div>
    );
  }

  return (
    <div>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
        />
      ))}

      <div style={filterBarStyle}>
        <div style={filterGroupStyle}>
          <Input
            placeholder="Search companies..."
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            }
          />
        </div>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end' }}>
          <Button variant="secondary" onClick={loadCompanies}>
            Refresh
          </Button>
        </div>
      </div>

      <DataTable columns={columns} data={filteredCompanies} />
    </div>
  );
};

export default ManagerCompanyView;
